<template>
	<div>
		<Head :title="category.name" />

		<Breadcrumbs
			href="/categories"
			:parentLabel="__('Categories')"
			:childLabel="category.name"
		/>

		<div class="w-full overflow-hidden bg-white rounded-md shadow">
			<CategoryForm
				:submit="update"
				:model="category"
				:label="__('Update Category')"
				:receiver_list="receiver_list"
				:all_users="all_users"
			/>
		</div>
	</div>
</template>

<script>
	import { Head } 	  from '@inertiajs/inertia-vue3'
	import Layout 		  from '@/Shared/Layout'
	import TrashedMessage from '@/Shared/TrashedMessage'
	import Breadcrumbs 	  from '@/Shared/Breadcrumbs'
	import CategoryForm   from './Form'

	export default {
		components: {
			Head,
			Breadcrumbs,
			TrashedMessage,
			CategoryForm,
		},
		layout: Layout,
		props: {
			category: Object,
			receiver_list: Array,
			all_users: Array,
		},
		data() {
			return {}
		},
		methods: {
			update(form) {
                form.products = null;
				form.post(`/categories/${ this.category.id }`, {
                    forceFormData: true,
                    preserveScroll: true,
					onSuccess: () => location.reload(true)
				})
			}
		}
	}
</script>
